<aca-page-layout>
  <div class="aca-page-layout-header">
    <h1 class="aca-page-title">{{ 'APP.CUSTOM_REPORTS.ACTIVITY_FEED_REPORT.TITLE' | translate }}</h1>
    <aca-toolbar [items]="actions"></aca-toolbar>
  </div>
  <div class="aca-page-layout-content">
    <div class="activity-feed-report-main-content">
      <form [formGroup]="activityFeedReportForm" novalidate (ngSubmit)="onFormSubmit()">
        <div id="wf-main-input-container">
          <div class="wfmic-section">
            <mat-form-field appearance="standard">
              <mat-label>{{ 'APP.CUSTOM_REPORTS.ACTIVITY_FEED_REPORT.SITE' | translate }}</mat-label>
              <mat-select formControlName="selectedSite" name="selectedSite">
                <mat-option *ngFor="let site of sites" [value]="site.id">{{ site.title }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'APP.CUSTOM_REPORTS.ACTIVITY_FEED_REPORT.DATE_FROM' | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="dateFromPicker"
                [max]="today"
                formControlName="dateFrom"
                name="dateFrom"
                readonly
              />
              <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateFromPicker disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="wfmic-section">
            <mat-form-field appearance="standard">
              <mat-label>{{ 'APP.CUSTOM_REPORTS.ACTIVITY_FEED_REPORT.USER' | translate }}</mat-label>
              <input matInput formControlName="user" name="user" />
            </mat-form-field>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'APP.CUSTOM_REPORTS.ACTIVITY_FEED_REPORT.DATE_TO' | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="dateToPicker"
                [max]="today"
                formControlName="dateTo"
                name="dateTo"
                readonly
              />
              <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateToPicker disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div id="wf-footer">
          <button mat-button type="button" (click)="onFormReset($event)">{{ 'APP.ACTIONS.RESET' | translate }}</button>
          <button mat-raised-button type="submit" color="primary" (click)="resetCurrentPage()">{{ 'APP.ACTIONS.GENERATE' | translate }}</button>
          <div class="loading-container">
            <div *ngIf="isLoading">{{ 'APP.CUSTOM_REPORTS.GENERAL.LOADING' | translate }}</div>
          </div>
        </div>
        <div *ngIf="!isLoading && (showDataTable || showActivityMessage)" id="wf-table">
          <div class="table-options">
            <mat-form-field appearance="standard" class="rows-dropdown">
              <mat-label>{{ 'APP.CUSTOM_REPORTS.GENERAL.ROWS' | translate }}</mat-label>
              <mat-select formControlName="itemsPerPage" (selectionChange)="onItemsPerPageChange($event.value)">
                <mat-option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="pagination">
              <button mat-icon-button type="button" [disabled]="currentPage <= 1" (click)="onPageChange(currentPage - 1)">
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
              <span>{{ currentPage }}</span>
              <button mat-icon-button type="button" [disabled]="currentPage >= totalPages" (click)="onPageChange(currentPage + 1)">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
            </div>
            <button mat-raised-button color="primary" *ngIf="showDataTable" (click)="printTable()" type="button">
              {{ 'APP.ACTIONS.PRINT' | translate }}
            </button>
          </div>
          <ng-container *ngIf="showDataTable">
            <table>
              <thead>
                <tr>
                  <th *ngFor="let column of tableColumns">{{ column.title }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of tableRows; let i = index">
                  <td *ngFor="let column of tableColumns">
                    <span *ngIf="column.key !== 'activitySummary'">{{ row[column.key] }}</span>
                    <span *ngIf="column.key === 'activitySummary'" (click)="onActivityClick(i)" class="link">{{ row[column.key] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
          <div *ngIf="showActivityMessage">
            {{ 'APP.CUSTOM_REPORTS.ACTIVITY_FEED_REPORT.NO_ACTIVITY_ITEMS' | translate }}
          </div>
        </div>
      </form>
    </div>
  </div>
</aca-page-layout>
